import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'acabim-admin-lkm-config',
  templateUrl: './lkm-config.component.html',
  styleUrls: ['./lkm-config.component.scss']
})
export class LkmConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
